module.exports = __webpack_public_path__ + "img/Foto_Digiasia_Bios_All_2_DSA_2.528c3327.jpeg";